import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { WifiProfileEffects } from './wifi-profile.effects';
import { wifiProfilesReducer } from './wifi-profile.reducer';
import { WifiProfileService } from './wifi_profile.service';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('wifiProfiles', wifiProfilesReducer),
    EffectsModule.forFeature([WifiProfileEffects]),
  ],
  providers: [WifiProfileService],
})
export class WifiProfilestoreModule {}
